module.exports = __webpack_public_path__ + "img/about-familiar-unexpected.669bf5c2.jpg";